// Eyedropper (I): click an object to copy its appearance — onto the selected objects, or, with nothing
// selected, into the current appearance that new objects get.
import type { Tool, ToolHost, ToolPointer } from './tool';
import { useDesign } from '../state';
import { useDesignUi } from '../ui/designUi';
import { hitItem } from '../geometry/hitTest';
import { setAppearance } from '../commands/commands';

export class EyedropperTool implements Tool {
  down(p: ToolPointer, h: ToolHost) {
    const it = hitItem(h.list, p.wx, p.wy, 3 * p.px);
    if (!it) return;
    const look = structuredClone(it.node.appearance);
    const ui = useDesignUi.getState();
    const targets = ui.selection.filter((id) => id !== it.topId);
    if (targets.length)
      useDesign.getState().run(
        setAppearance(targets, (a) => {
          a.fills = structuredClone(look.fills);
          a.strokes = structuredClone(look.strokes);
          a.opacity = look.opacity;
          a.blend = look.blend;
          a.effects = structuredClone(look.effects);
        }),
      );
    else ui.set({ current: look });
  }
  move(_p: ToolPointer, h: ToolHost) {
    h.setCursor('copy');
  }
  up() {}
}
